import {FC, useState} from 'react'
import {bookingCalendar} from "../../constants/global";
import {isServiceActive, storeBooking} from "../../lib/booking";

interface Props {
    booking:Booking,
    workshops:any[],
}

const WorkshopMessage: FC<Props> = ({booking, workshops}) => {

    if(!booking.contact.workshop)
        return

    const workshop = workshops.find(obj => { return obj.id === booking.contact.workshop })

    return (
        <div className={'workshop-message'}>
            Du har dina däck förvarade hos Mechanum {workshop.name}.
        </div>
    )
};

export default WorkshopMessage
